import { List, Create, Edit, LinkUsers } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/group",
        component: List,
        name: "setting.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/group/:id/edit",
        component: Edit,
        name: "setting.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/group/:id/users",
        component: LinkUsers,
        name: "setting.group.users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/group/create",
        component: Create,
        name: "setting.group.create",
        meta: {
            requiresAuth: true,
        },
    },
];
